import { ShaderBase, IShader } from '../shader';

import { Material, Scene } from '@babylonjs/core';

export class ShaderFloorWithFlexibleSlatsFrame extends ShaderBase implements IShader {

    public diffuse: string = '';
    public normal: string = '';
    public avatar: string = 'bed2_icon.png';
    public text: string = 'floorWithFlexibleSlats';
    public key: string = 'ShaderFloorWithFlexibleSlatsFrame';

    public getMaterial(scene: any): Material {
        return new Material('', scene);
    }

    addLight(scene: Scene, material: Material, light: string): Material {
        return material;
    }
}